import fridge from '../images/product/fridge.png'
import lap from '../images/product/laptop.png'
import speakers from '../images/product/speakers.png'
import boat from '../images/product/boat.png'
import sofa from '../images/product/sofaset.png'
import coffee from '../images/product/coffeeCup.jpg'
import tv from '../images/product/samtv.png'
import sw from '../images/product/sweater.png'
import p from '../images/product/iphone14Pro.jpg'
import h from '../images/product/hoodie.png'

const Products=[
    
    {
        id:5,
        name:'Fridge',
        price:28999,
        highlight1:'Spacious and Versatile Interiors',
        imgurl:fridge
    },
    {
        id:52,
        name:'asus rog laptop',
        price:99999,
        highlight1:'Unmatched Gaming Performance',
        imgurl:lap
    },
    {
        id:35,
        name:'Logi speakers',
        price:5899,
        highlight1:'Crystal-Clear Audio',
        imgurl:speakers
    },
    {
        id:24,
        name:'Boat smart watch',
        price:1100,
        highlight1:'Comprehensive Health and Fitness Tracking',
        imgurl:boat
    },
    {
        id:20,
        name:'Coffe cup',
        price:120,
        highlight1:'Superior Thermal Insulation',
        imgurl:coffee
    },
    {
        id:42,
        name:'Premium sofaset',
        price:14999,
        highlight1:'Contemporary Elegance',
        imgurl:sofa
    },
    
    {
        id:23,
        name:'Samsung smart tv',
        price:75000,
        highlight1:'Crystal Clear 4K Resolution',
        imgurl:tv
    },
    {
        id:16,                      
        name:'Sweater',
        price:599,
        highlight1:'Trensetting designs',
        imgurl:sw
    },
    {
        id:48,
        name:'iphone 14 pro max',
        price:149999,
        highlight1:'Exceptional Camera Capabilities',
        imgurl:p
    },
    {
        id:4,
        name:'Hoodie',
        price:199,
        highlight1:'stylish',
        imgurl:h
    }
]

export default Products;